export default {"src":"/education/_next/static/media/close-circle.d5a85fa0.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};